var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTcr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 6.1L12.7 5.2L10.9 0.6C10.8 0.2 10.4 0 10 0H1C0.4 0 0 0.4 0 1V13C0 13.6 0.4 14 1 14H4.3C4.9 15.2 6.1 16 7.5 16C8.9 16 10.1 15.2 10.7 13.9C10.8 13.9 10.9 14 11 14H15C15.6 14 16 13.6 16 13V7C16 6.6 15.7 6.2 15.3 6.1ZM14 12H11C10.8 10.3 9.3 9 7.5 9C5.7 9 4.3 10.3 4.1 12H2V2H9.3L11 6.4C11.1 6.7 11.3 6.9 11.6 7L14 7.7V12Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H5V6C5 6.6 5.4 7 6 7H9V5H7V3Z",
    fill: "#8E8E8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTcr);
export default __webpack_public_path__ + "static/media/icon_tcr.37b92abe.svg";
export { ForwardRef as ReactComponent };